import type { ColDef } from 'ag-grid-community'
import { StatusCellRenderer } from '../renderers/StatusCellRenderer'
import { InvoiceNumberClickableCellRenderer } from '../renderers/InvoiceNumberClickableCellRenderer'
import { MATCH_STATUS_CONFIG } from '../../../../MatchView/constants/statusConfig'

export const invoiceColumnDefs: ColDef[] = [
  {
    headerName: 'Invoice #',
    field: 'invoiceNumber',
    flex: 1,
    cellRenderer: InvoiceNumberClickableCellRenderer,
    filter: 'agSetColumnFilter',
  },
  {
    headerName: 'Supplier',
    field: 'supplierName',
    flex: 1,
    filter: 'agSetColumnFilter',
  },
  {
    headerName: 'Status',
    field: 'status',
    flex: 1,
    cellRenderer: StatusCellRenderer,
    filter: 'agSetColumnFilter',
    filterValueGetter: (params) => {
      const config = MATCH_STATUS_CONFIG[params.data.status]
      return config?.display || params.data.status
    },
  },
  {
    headerName: 'Invoice BOL Date',
    field: 'invoiceBolDate',
    flex: 1,
    filter: 'agDateColumnFilter',
    sort: 'asc',
    valueFormatter: (params) => {
      if (!params.value) return 'N/A'
      return new Date(params.value).toLocaleDateString()
    },
  },
  {
    headerName: 'Days Until Due',
    field: 'daysUntilDue',
    flex: 1,
    filter: 'agNumberColumnFilter',
    comparator: (a: number, b: number) => {
      const numA = Number.isNaN(a) ? Infinity : a
      const numB = Number.isNaN(b) ? Infinity : b
      return numA - numB
    },
    cellStyle: (params: any) => {
      const days = params.value
      const baseStyle = { textAlign: 'right', fontWeight: 'bold' }
      if (days < 0) {
        return { ...baseStyle, color: '#ff4d4f' } // Red for past due
      } else if (days === 0) {
        return { ...baseStyle, color: '#ff4d4f' } // Red for due today
      } else {
        return { ...baseStyle, color: '#000' } // Black for not due yet
      }
    },
    valueFormatter: (params: any) => {
      if (Number.isNaN(params.value)) return 'N/A'
      return params.value
    },
  },
  {
    headerName: 'Amount Due',
    field: 'amountDue',
    type: 'rightAligned',
    width: 150,
    cellStyle: { textAlign: 'right', fontWeight: 'bold' },
    filter: 'agNumberColumnFilter',
    pinned: 'right',
    valueFormatter: (params) => {
      const amount = params.value || 0
      return `$${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    },
  },
]
